import AccessGroupsStore from 'es/app/views/system/access-groups/AccessGroupsStore';
import { useLocalObservable } from 'mobx-react';
import React, { useContext } from 'react';

const createSystemStore = () => ({
    accessGroupsStore: new AccessGroupsStore(),
});

type SystemStore = ReturnType<typeof createSystemStore>;
const SystemStoresContext = React.createContext<SystemStore | null>(null);

export const SystemStoresProvider = (props: React.PropsWithChildren<unknown>) => {
    const store = useLocalObservable<SystemStore>(createSystemStore);

    return <SystemStoresContext.Provider value={store}>{props.children}</SystemStoresContext.Provider>;
};

export const useSystemStore = () => useContext(SystemStoresContext);

export const useAccessGroupsStore = () => useSystemStore()?.accessGroupsStore;
